import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"plus\"><path d=\"M28.733 18.506H18.5l-.085 10.234c-.005.69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.255-.56-1.25-1.25l.085-10.234H3.267c-.69 0-1.25-.56-1.25-1.25v-2.5c0-.69.56-1.25 1.25-1.25H13.5l.037-10.246c.002-.69.56-1.25 1.25-1.25h2.5c.69 0 1.252.56 1.25 1.25L18.5 13.506h10.233c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol